import { getHidratationKey } from '@portal-internet/core';
import Text from 'components/corporatiu/Text';
import Titol from 'components/corporatiu/Titol';
import __isEmpty from 'lodash/isEmpty';
import styles from './onsom.module.scss';
import Desplegable from 'components/corporatiu/Desplegable';

export default function OnSom(props) {
    const { items } = props;

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            <div className={styles.mapa}>
                <iframe title='Mapa on som' src='https://mapsengine.google.com/map/embed?mid=zqX79HFuV7jI.kqCmcqtvcbI0'></iframe>
            </div>

            <div className={styles.adreces}>
                <address className={`${styles.vcard} vcard`}>
                    <span className={`${styles.org} org`}>
                        <span className='fn organization-name title gapHalfAfter'>
                            <strong>Corporació Catalana de Mitjans Audiovisuals - 3Cat</strong>
                        </span>
                    </span>
                    <span className={`${styles.lineAdress} line adr`}>
                        <span className='street-address line'>
                            <strong>Domicili social</strong>: Oriol Martorell, 1
                        </span>
                        <span className='street-address line'>
                            <strong>Accés visites</strong>: carrer de la TV3, s/n
                        </span>
                        <span className='line postal-code'>08970 Sant Joan Despí, Barcelona</span>
                    </span>
                    <span className='line tel line'>
                        <span className='ico-phone'>
                            &nbsp;
                            <a className='line-phone' href='tel:+34934444800'>
                                (+34) 93 444 48 00
                            </a>
                        </span>
                    </span>
                    <span className='link'>
                        <a
                            title='Corporació Catalana de Mitjans Audiovisuals - 3Cat'
                            href='https://www.3cat.cat/'
                            className={`${styles.url} url`}
                        >
                            www.3cat.cat
                        </a>
                    </span>
                </address>
                <address className={`${styles.vcard} vcard`}>
                    <span className={`${styles.org} org`}>
                        <span className='fn organization-name title gapHalfAfter'>
                            <strong>Televisió de Catalunya</strong>
                        </span>
                    </span>
                    <span className={`${styles.lineAdress} line adr`}>
                        <span className='street-address line'>
                            <strong>Domicili social</strong>: Oriol Martorell, 1
                        </span>
                        <span className='street-address line'>
                            <strong>Accés visites</strong>: carrer de la TV3, s/n
                        </span>
                        <span className='line postal-code'>08970 Sant Joan Despí, Barcelona</span>
                    </span>
                    <span className='line tel line'>
                        <span className='ico-phone'>
                            &nbsp;
                            <a className='line-phone' href='tel:+34934999333'>
                                (+34) 93 499 93 33
                            </a>
                        </span>
                    </span>
                    <span className='link'>
                        <a title='Televisió de Catalunya' href='https://www.3cat.cat/tv3/' className={`${styles.url} url`}>
                            www.3cat.cat/tv3
                        </a>
                    </span>
                </address>

                <address className={`${styles.vcard} vcard`}>
                    <span className={`${styles.org} org`}>
                        <span className='fn organization-name title gapHalfAfter'>
                            <strong>Catalunya Ràdio</strong>
                        </span>
                    </span>
                    <span className={`${styles.lineAdress} line adr`}>
                        <span className='street-address line'>Avinguda Diagonal, 614-616</span>
                        <span className='line postal-code'>08021 Barcelona</span>
                    </span>
                    <span className='line tel line'>
                        <span className='ico-phone'>
                            &nbsp;
                            <a className='line-phone' href='tel:+34933069200'>
                                (+34) 93 306 92 00
                            </a>
                        </span>
                    </span>
                    <span className='link'>
                        <a title='Catalunya Ràdio' href='https://www.3cat.cat/catradio/' className={`${styles.url} url`}>
                            www.3cat.cat/catradio
                        </a>
                    </span>
                </address>

                <address className={`${styles.vcard} vcard`}>
                    <span className={`${styles.org} org`}>
                        <span className='fn organization-name title gapHalfAfter'>
                            <strong>Fundació La Marató de 3Cat</strong>
                        </span>
                    </span>
                    <span className={`${styles.lineAdress} line adr`}>
                        <span className='street-address line'>
                            <strong>Domicili social</strong>: Oriol Martorell, 1
                        </span>
                        <span className='street-address line'>
                            <strong>Accés visites</strong>: carrer de la TV3, s/n
                        </span>
                        <span className='line postal-code'>08970 Sant Joan Despí, Barcelona</span>
                    </span>
                    <span className='line tel line'>
                        <span className='ico-phone'>
                            &nbsp;
                            <a className='line-phone' href='tel:+34934999333'>
                                (+34) 93 499 93 33
                            </a>
                        </span>
                    </span>
                    <span className='link'>
                        <a
                            title='Fundació La Marató de 3Cat'
                            href='https://www.3cat.cat/tv3/marato/'
                            className={`${styles.url} url`}
                        >
                            www.3cat.cat/tv3/marato
                        </a>
                    </span>
                </address>
            </div>

            <Desplegable
                key={getHidratationKey(items?.delegacions)}
                titol={items?.delegacions}
                className={styles.textDesplegable}
                tag='h2'
            >
                <div className={styles.contingutDesplegable}>
                    <Text text='GIRONA' tag='h3' />
                    <div className={styles.adreces}>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>TV3</strong>
                                </span>
                            </span>
                            <span className='note separador'>Francesc Sànchez Trigueros</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Ronda Fort Roig, 20</span>
                                <span className='line postal-code'>17007 Girona</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:tv3girona@3cat.cat'>tv3girona@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34972213738'>(+34) 972 21 37 38</a>
                            </span>
                        </address>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>Catalunya Ràdio</strong>
                                </span>
                            </span>
                            <span className='note separador'>Núria Peraire Panadès</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Ctra. Barcelona, 33, 4t</span>
                                <span className='line postal-code'>17001 Girona</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:informatiusgirona@3cat.cat'>informatiusgirona@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34972213738'>(+34) 972 21 37 38</a>
                            </span>
                        </address>
                    </div>

                    <Text text='LLEIDA' tag='h3' />
                    <div className={styles.adreces}>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>TV3</strong>
                                </span>
                            </span>
                            <span className='note separador'>Teresa Macià Viles</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Avinguda de l&apos;Exèrcit, 33, 3r 7a</span>
                                <span className='line postal-code'>25194 Lleida</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:tv3lleida@3cat.cat'>tv3lleida@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34973233029'>(+34) 973 23 30 29</a>
                            </span>
                        </address>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>Catalunya Ràdio</strong>
                                </span>
                            </span>
                            <span className='note separador'>Noèlia Casellas González</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Vallcalent, 1, 8è D</span>
                                <span className='line postal-code'>25003 Lleida</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:informatiuslleida@3cat.cat'>informatiuslleida@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34973678112'>(+34) 973 67 81 12</a>
                            </span>
                        </address>
                    </div>

                    <Text text='TARRAGONA' tag='h3' />
                    <div className={styles.adreces}>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>TV3</strong>
                                </span>
                            </span>
                            <span className='note separador'>Anna Masip Elias</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Marquès de Montoliu, 4, baixos</span>
                                <span className='line postal-code'>43002 Tarragona</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:tv3tarragona@3cat.cat'>tv3tarragona@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34977230231'>(+34) 977 23 02 31</a>
                            </span>
                        </address>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>Catalunya Ràdio</strong>
                                </span>
                            </span>
                            <span className='note separador'>Coia Ballesté Brumós</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Ramon i Cajal, 36, 3r</span>
                                <span className='line postal-code'>43001 Tarragona</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:informatiustarragona@3cat.cat'>informatiustarragona@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34977219933'>(+34) 977 21 99 33</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34977219919'>(+34) 977 21 99 19</a>
                            </span>
                        </address>
                    </div>

                    <Text text='ARAN' tag='h3' />
                    <div className={styles.adreces}>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>TV3</strong>
                                </span>
                            </span>
                            <span className='note separador'>Jovita Ané Sanz</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Av. Garona, 33, Palai de Gèu</span>
                                <span className='line postal-code'>25530 Vielha</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:tv3valldaran@3cat.cat'>tv3valldaran@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34973642523'>(+34) 973 64 25 23</a>
                            </span>
                        </address>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>Catalunya Ràdio</strong>
                                </span>
                            </span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Av. Garona, 33, Palai de Gèu</span>
                                <span className='line postal-code'>25530 Vielha</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:aran@3cat.cat'>aran@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34973642434'>(+34) 973 64 24 34</a>
                            </span>
                        </address>
                    </div>

                    <Text text='CATALUNYA NORD' tag='h3' />
                    <div className={styles.adreces}>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>TV3 i Catalunya Ràdio</strong>
                                </span>
                            </span>
                            <span className='note separador'>Laura Bertran</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>1, carrer de la Fusteria / Rue de la Fusterie</span>
                                <span className='line postal-code'>F-66000 Perpinyà</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:catalunyanord@3cat.cat'>catalunyanord@3cat.cat</a>
                            </span>
                        </address>
                    </div>

                    <Text text='PAÍS VALENCIÀ' tag='h3' />
                    <div className={styles.adreces}>
                        <address className={`${styles.vcard} vcard`}>
                            <span className={`${styles.org} org`}>
                                <span className='fn organization-name title gapHalfAfter'>
                                    <strong>TV3</strong>
                                </span>
                            </span>
                            <span className='note separador'>Pepa Ferrer Bolta</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Carrer Ambaixador Vich, 3, 2a E</span>
                                <span className='line postal-code'>46002 València</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:valencia@3cat.cat'>valencia@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34963512711'>(+34) 963 51 27 11</a>
                            </span>
                        </address>
                    </div>

                    <Text text='ILLES BALEARS' tag='h3' />
                    <div className={styles.adreces}>
                        <address className={`${styles.vcard} vcard`}>
                            <span className='note separador'>Caterina Karmany Jaume</span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Av. Alexandre Rosselló, 31, 2n</span>
                                <span className='line postal-code'>07002 Palma</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:tv3palma@3cat.cat'>tv3palma@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34607071048'>(+34) 607 07 10 48</a>
                            </span>
                        </address>
                    </div>

                    <Text text='MADRID' tag='h3' />
                    <div className={styles.adreces}>
                        <address className={`${styles.vcard} vcard`}>
                            <span className='note separador'>
                                Pol Marsà Dot, delegat
                                <br />
                                Paula Brujats Rubirola, sotsdelegada
                            </span>
                            <span className={`${styles.lineAdress} line adr`}>
                                <span className='street-address line'>Bocángel, 26</span>
                                <span className='line postal-code'>28028 Madrid</span>
                            </span>
                            <span className='email line'>
                                <a href='mailto:madrid@3cat.cat'>madrid@3cat.cat</a>
                            </span>
                            <span className='tel line'>
                                <a href='tel:+34915124959'>(+34) 915 12 49 59</a>
                            </span>
                        </address>
                    </div>
                </div>
            </Desplegable>

            <Desplegable
                key={getHidratationKey(items?.corresponsalies)}
                titol={items?.corresponsalies}
                className={styles.textDesplegable}
                tag='h2'
            >
                <div className={styles.contingutDesplegable}>
                    <div className='gapAfter'>
                        <Text text={items?.corresponsalies_title} className={styles.sotstitol} />
                    </div>

                    <div className={styles.adreces}>
                        <div>
                            <Text text='BRUSSEL·LES' tag='h3' />
                            <address className={`${styles.vcard} vcard`}>
                                <span className={`${styles.org} org`}>
                                    <span className='fn organization-name title gapHalfAfter'>
                                        <strong>TV</strong>
                                    </span>
                                </span>
                                <span className='note separador'>Pilar Abril Novella</span>
                                <span className='email line'>
                                    <a href='mailto:pabril.o@3cat.cat'>pabril.o@3cat.cat</a>
                                </span>
                                <span className={`${styles.org} org`}>
                                    <span className='fn organization-name title gapHalfAfter'>
                                        <strong>RÀDIO</strong>
                                    </span>
                                </span>
                                <span className='note separador'>Bruno Fortea Miras</span>
                                <span className='email line'>
                                    <a href='mailto:bfortea.c@3cat.cat'>bfortea.c@3cat.cat</a>
                                </span>
                            </address>
                        </div>

                        <div>
                            <Text text='JERUSALEM' tag='h3' />

                            <address className={`${styles.vcard} vcard`}>
                                <span className='note separador'>Jordi Brescó Montserrat</span>
                                <span className='email line'>
                                    <a href='mailto:jbresco.n@3cat.cat'>jbresco.n@3cat.cat</a>
                                </span>
                            </address>
                        </div>

                        <div>
                            <Text text='MOSCOU' tag='h3' />

                            <address className={`${styles.vcard} vcard`}>
                                <span className='note separador'>Cristina Solías Marín</span>
                                <span className='email line'>
                                    <a href='mailto:csolias.n@3cat.cat'>csolias.n@3cat.cat</a>
                                </span>
                            </address>
                        </div>

                        <div>
                            <Text text='PARÍS' tag='h3' />

                            <address className={`${styles.vcard} vcard`}>
                                <span className='note separador'>Isabel Galí Izard</span>
                                <span className='email line'>
                                    <a href='mailto:igali.g@3cat.cat'>igali.g@3cat.cat</a>
                                </span>
                            </address>
                        </div>

                        <div>
                            <Text text='PEQUÍN' tag='h3' />

                            <address className={`${styles.vcard} vcard`}>
                                <span className='note separador'>Francesc Canals Furné</span>
                                <span className='email line'>
                                    <a href='mailto:fcanals.d@3cat.cat'>fcanals.d@3cat.cat</a>
                                </span>
                            </address>
                        </div>

                        <div>
                            <Text text='LONDRES' tag='h3' />

                            <address className={`${styles.vcard} vcard`}>
                                <span className='note separador'>Quim Olivares Aguilar</span>
                                <span className='email line'>
                                    <a href='mailto:jolivares.x@3cat.cat'>jolivares.x@3cat.cat</a>
                                </span>
                            </address>
                        </div>

                        <div>
                            <Text text='WASHINGTON' tag='h3' />

                            <address className={`${styles.vcard} vcard`}>
                                <span className={`${styles.org} org`}>
                                    <span className='fn organization-name title gapHalfAfter'>
                                        <strong>TV</strong>
                                    </span>
                                </span>
                                <span className='note separador'>Lídia Heredia Soler</span>
                                <span className='email line'>
                                    <a href='mailto:lheredia.k@3cat.cat'>lheredia.k@3cat.cat</a>
                                </span>
                                <span className={`${styles.org} org`}>
                                    <span className='fn organization-name title gapHalfAfter'>
                                        <strong>RÀDIO</strong>
                                    </span>
                                </span>
                                <span className='note separador'>Oriol Serra Hernandez</span>
                                <span className='email line'>
                                    <a href='mailto:oserra.i@3cat.cat'>oserra.i@3cat.cat</a>
                                </span>
                            </address>
                        </div>
                    </div>
                    <div className='gapAfter'>
                        <Text text={items?.corresponsalies_other} className={styles.sotstitol} />
                    </div>

                    <div className={styles.adreces}>
                        <div>
                            <Text text='ÀFRICA' tag='h3' />

                            <address className={`${styles.vcard} vcard`}>
                                <span className='note separador'>Gemma Parellada Pareja</span>
                                <span className='email line'>
                                    <a href='mailto:gemma@periodistes.org'>gemma@periodistes.org</a>
                                </span>
                            </address>
                        </div>

                        <div>
                            <Text text='BUENOS AIRES' tag='h3' />

                            <address className={`${styles.vcard} vcard`}>
                                <span className='note separador'>Joan Biosca Capdevila</span>
                                <span className='email line'>
                                    <a href='mailto:joanbioscacapdevila@gmail.com'>joanbioscacapdevila@gmail.com</a>
                                </span>
                            </address>
                        </div>
                    </div>
                </div>
            </Desplegable>
        </>
    );
}
